import React from 'react';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { PmpModality } from '../../../../api/pmpModalities';

interface IProps {
  modality: PmpModality;
  onEdit: (modality: PmpModality) => void;
  onToggleStatus: (modality: PmpModality) => void;
}

const formatPrice = (price: number | null | undefined): string => {
  if (price === null || price === undefined) return '-';
  return Number(price).toFixed(2);
};

const PmpModalitiesTableRow: React.FC<IProps> = ({
  modality,
  onEdit,
  onToggleStatus,
}) => {
  const isActive = modality.is_active !== false;

  const onOptionClick = async (_id: number, action: string) => {
    if (action === 'edit') {
      onEdit(modality);
    }
    if (action === 'toggle') {
      onToggleStatus(modality);
    }
  };

  return (
    <div className={`table-row pmp-modalities-table-row ${!isActive ? 'is-inactive' : ''}`}>
      <div className='name'>{modality.name}</div>
      <div className='modality-full-price'>{formatPrice(modality.full_price)}</div>
      <div className='modality-member-price'>{formatPrice(modality.member_price)}</div>
      <div className='status'>
        <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
          {isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            { key: 'toggle', value: isActive ? 'Deactivate' : 'Activate' },
          ]}
          id={modality.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default PmpModalitiesTableRow;
